module.exports = __webpack_public_path__ + "img/D1M9_new.47e88edb.jpg";